/* eslint-disable */
<template>
  <!-- Content Wrapper -->
  <div class="content">
    <!-- Main Content -->
    <!-- <div class="container-fluid"> -->
    <!-- <div> -->

    <section v-for="(value, key) in this.csummarytot" :key="key">

      <!-- <section class="flexib-container"> -->
        <!-- <div style="text-align:left;"><small>State: {{}}</small></div> -->
        <div style="text-align:right;">
          <small>Last Updated: {{value.lastupdatedtime}}<i> - API: {{apiurl}}</i></small>
        </div>
      <!-- </section> -->

      <div class="flex-container">
        <div class="card shadow" id = "confirmed">
          <div class="card-body">
            <div class="flex-container">
              <div>
                <div><strong>Confirmed</strong></div>
                <div>{{ value.confirmed | formatIt }}</div>
              </div>
              <div>
                <!-- <i :class = "confirmed"></i> -->
                <span class = "iconsm">{{confirmed}}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="card shadow" id = "active">
          <div class="card-body">
            <div class="flex-container">
              <div>
                <div><strong>Active</strong></div>
                <div>{{ value.active | formatIt }}</div>
              </div>
              <div>
                <!-- <i :class = "active"></i> -->
                <span class = "iconsm">{{active}}</span>
                <div>{{value.activepct}}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="card shadow" id = "recovered">
          <div class="card-body">
            <div class="flex-container">
              <div>
                <div><strong>Recovered</strong></div>
                <div>{{ value.recovered | formatIt }}</div>
              </div>
              <div>
                <!-- <div><i :class = "recovered"></i></div> -->
                <span class = "iconsm">{{recovered}}</span>
                <div>{{value.recoveredpct}}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="card shadow" id = "deaths">
          <div class="card-body">
            <div class="flex-container">
              <div>
                <div><strong>Deaths</strong></div>
                <div>{{ value.deaths | formatIt }}</div>
              </div>
              <div>
                <!-- <div><i :class = "deaths"></i></div> -->
                <span class = "iconsm">{{deaths}}</span>
                <div>{{value.deathspct}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <div class="statedata">
      <rgrid :gdata=gridData :columns=this.gridColumns :footer=this.gridFooter :hasDetail=true></rgrid>
    </div>

    <!-- </div> -->
    <!-- </div> -->
  </div>
</template>
<script>
import axios from "axios";
import wsm from "../mixin/mixin";

import { APIServiceCovid } from "../apis/apiservices";
import Rgrid from "../components/layout/Rgrid.vue";
import Reactive from "../components/layout/Reactive.vue";

// import LineChart from "../components/layout/Linechart.vue";
// import BarChart from "../components/layout/barchart.vue";

const apiService = new APIServiceCovid();

function formatIt(value) {
  const formatter = new Intl.NumberFormat("en-IN", {
    /*   style: 'currency', currency: 'USD', */
    minimumFractionDigits: 0
  });
  // if (typeof value === "number") {
  //   return value;
  // }
  return formatter.format(value);
}

export default {
  components: {
    // Reactive
    Rgrid
  },
  data() {
    return {
      csummary: {},
      csummarytot: {},
      apiurl: "https://api.covid19india.org",
      // apiurl: https://api.covid19india.org/state_district_wise.json
      // imgurl: "",
      // wrc: [
      //   { lbl: "World", value: "world", icon: "fas fa-fw fa-globe-asia" },
      //   { lbl: "Countries", value: "ctry", icon: "fas fa-fw fa-flag" }
      // ],
      // worldrcntry: "world",
      // clist: "IND",
      // cntrys: [
      //   { name: "Afghanistan", iso2: "AF", iso3: "AFG" },
      //   { name: "Albania", iso2: "AL", iso3: "ALB" },
      //   { name: "India", iso2: "IN", iso3: "IND" }
      // ],
      wdchartdata: {},
      imagesize: { height: "37%", width: "31%" },
      isLoading: false,
      confirmed: "😐",
      deaths: "😟",
      recovered: "🙂",
      active: "🤨",
      gridData: [],
      // gridColumns: [],
      gridColumns: ["state", "confirmed", "active", "activepct", "recovered", "deaths"],
      gridFooter:
        "Let's keep the fight, together we shall conquer Covid19🦠😷.... <a href='https://www.mygov.in/covid-19' target='_blank' rel='external'>Check this!</a>.",
    };
  },
  mixins: [wsm],
  filters: { formatIt },
  methods: {
    filterData(items) {
      const result = {};
      Object.keys(items).forEach(key => {
        const item = items[key];
        this.$set(item, "activepct", `${Math.round(((parseInt(item.active, 10) / item.confirmed) * 100) * 100) / 100} %`);
        this.$set(item, "recoveredpct", `${Math.round(((parseInt(item.recovered, 10) / item.confirmed) * 100) * 100) / 100} %`);
        this.$set(item, "deathspct", `${Math.round(((parseInt(item.deaths, 10) / item.confirmed) * 100) * 100) / 100} %`);

        result[key] = item;
      });
      return result;
    },
    // world level summary and country wise data
    async getsummary() {
      const url = `${this.apiurl}/data.json`;
      this.isLoading = false;
      let isTotal = true;
      this.csummarytot = await apiService.getDataIndiaDtl(isTotal, url);
      this.isLoading = true;
      this.csummarytot = this.filterData(this.csummarytot);

      this.isLoading = false;
      isTotal = false;
      this.csummary = await apiService.getDataIndiaDtl(isTotal, url);
      this.isLoading = true;
      // this.csummary = this.filterData(this.csummary);
      this.gridData = this.csummary;

      // this.getchartdata();
      this.isLoading = false;
    },
    // get the data for chart preparation!
    async getchartdata() {
      let url = `${this.apiurl}/daily`;
      if (this.worldrcntry !== "world") {
        url = `${this.apiurl}/countries/${this.clist}`;
      }

      apiService
        .getDataGlobal(url)
        .then(data => {
          this.isLoading = false;
          const xaxislabel = [];
          const yaxisdata1 = [];
          const yaxisdata2 = [];

          this.wdchartdata = {
            // Data for the y-axis of the chart
            labels: xaxislabel,
            datasets: [
              {
                label: "Confrmed",
                backgroundColor: "#f87979",
                // Data for the x-axis of the chart
                data: yaxisdata1
              },
              {
                label: "Deaths",
                backgroundColor: "blue",
                // Data for the x-axis of the chart
                data: yaxisdata2
              }
            ]
          };
        })
        .catch(error => {
          console.error(error);
        })
        .finally(error => {
          this.isLoading = false;
        });
    },
  },
  computed: {
    chartSizepx() {
      return {
        height: "280px", width: "400px",
      };
    },
    chartSizepct() {
      return {
        height: "60%", width: "45%",
      };
    },
  },
  mounted() {
    this.getsummary();
  },
  created() {
    this.setTitle(`Covi9 19 Stats : ${this.$route.name}`);
    // this.worldrcntry = "world";
    // this.getsummary();
  }
};
</script>

<style scoped lang="scss">
  @import "../scss/world";
</style>
